import * as stylex from "@stylexjs/stylex";

import {
  colors,
  fontSize,
  fontWeight,
  radius,
  space,
} from "@animus/primaris/tokens.stylex";

export const styles = stylex.create({
  container: {
    display: "flex",
    alignItems: "center",
    gap: space.sm,
    marginTop: `calc(-1 * ${space.xl})`,
    marginLeft: `calc(-1 * ${space.lg})`,
    marginBottom: space.lg,
  },
  toggleButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    padding: 0,
    borderWidth: 0,
    borderRadius: radius.md,
    backgroundColor: colors.transparent,
    cursor: "pointer",
    transition: "background-color 150ms ease-out",
    ":hover": {
      backgroundColor: colors.backgroundSubtle,
    },
  },
  breadcrumbs: {
    display: "flex",
    alignItems: "center",
    gap: space.xs,
    flex: 1,
    minWidth: 0,
  },
  breadcrumbItem: {
    display: "flex",
    alignItems: "center",
    gap: space.xs,
    minWidth: 0,
  },
  breadcrumbLink: {
    padding: 0,
    borderWidth: 0,
    backgroundColor: colors.transparent,
    color: colors.foregroundMuted,
    fontSize: fontSize.sm,
    fontWeight: fontWeight.normal,
    cursor: "pointer",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    transition: "color 150ms ease-out",
    ":hover": {
      color: colors.foreground,
    },
  },
  breadcrumbCurrent: {
    color: colors.foreground,
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  chevron: {
    flexShrink: 0,
    color: colors.foregroundSubtle,
  },
});
